import * as ExpoFileSystem from 'expo-file-system';
import {Platform} from 'react-native';
import {Folder, Media} from '../types';
import {writeItem} from './db';
import {getBlobForArrayBuffer} from './util';

import * as ExpoDocumentPicker from 'expo-document-picker';
import {createBlobDB} from './blobdb';
import {
  AssetType,
  Dirs,
  FileStat,
  FileSystem,
} from 'react-native-file-access';
import {useShare} from '../hooks/useShare';

export async function* streamFileChunks(
  path: string,
  bytesOffset: number,
  chunkSize: number,
  byteEnd: number,
) {
  let currentOffset = bytesOffset;
  while (currentOffset < byteEnd) {
    const buf = Buffer.from(
      await FileSystem.readFileChunk(
        path,
        currentOffset,
        chunkSize,
        'base64',
      ),
      'base64',
    );
    currentOffset += chunkSize;
    yield buf;
  }
}
function iteratorToStream(
  iterator: ReturnType<typeof streamFileChunks>,
) {
  return new ReadableStream({
    async pull(controller) {
      const {value, done} = await iterator.next();

      if (done) {
        controller.close();
      } else {
        controller.enqueue(value);
      }
    },
  });
}
export const streamFile = (
  path: string,
  bytesOffset: number,
  chunkSize: number,
  byteEnd: number,
) => {
  const streamGen = streamFileChunks(
    path,
    bytesOffset,
    chunkSize,
    byteEnd,
  );
  const stream = iteratorToStream(streamGen);
  stream.clone = () =>
    streamFile(path, bytesOffset, chunkSize, byteEnd);
  return stream;
};

export const checkFolderMobile = async (dirPath: string) => {
  console.info('checkFolderMobile', dirPath);
  try {
    const checkFolder = await ExpoFileSystem.readDirectoryAsync(
      dirPath,
    );
    console.info('dirctory exists', checkFolder);
    if (!checkFolder) {
      await ExpoFileSystem.makeDirectoryAsync(dirPath);
    }
  } catch (err) {
    await ExpoFileSystem.makeDirectoryAsync(dirPath);
  }
};

export const writeFileOpfs = async (
  media: Media,
  file: File | ExpoDocumentPicker.DocumentPickerAsset,
) => {
  if (Platform.OS === 'web') {
    const dirCore = await window.navigator.storage.getDirectory();
    const dir = await dirCore.getDirectoryHandle(media.folderId, {
      create: true,
    });
    const fileId = `${media.id}_${file.name}`;
    const fileHandle = await dir.getFileHandle(fileId, {
      create: true,
    });
    const writable = await fileHandle.createWritable();

    await writable.write(file);
    await writable.close();
    if (!media.isDownloaded) {
      media.isDownloaded = true;
      await writeItem(media);
    }
    return fileHandle;
  }
  // const documentDir =
  const dirPath =
    Platform.OS !== 'android'
      ? `${ExpoFileSystem.documentDirectory?.replace('file://', '')}${
          media.folderId
        }`
      : `${ExpoFileSystem.documentDirectory}${media.folderId}`;
  await checkFolderMobile(dirPath);
  const fileId = `${media.id}_${media.filename}`;
  const fileUri = `${dirPath}/${fileId}`;
  try {
    console.info(
      fileUri,
      (file as ExpoDocumentPicker.DocumentPickerAsset).uri,
    );
    await ExpoFileSystem.copyAsync({
      to: fileUri,
      from: (file as ExpoDocumentPicker.DocumentPickerAsset).uri,
    });
  } catch (err) {
    console.log('copy error', err);
  }
  console.info('final destination', fileUri.replace('file://', ''));
  return fileUri;
};

export const getFileStats = async (
  media: Media,
): Promise<FileStat | undefined> => {
  const fileData = await getFileReaderOpfs(media);
  if (!fileData) return undefined;
  if (Platform.OS === 'web') {
    const file = fileData as File & {
      filename: string;
      path: string;
      type: 'file';
    };
    return file;
  } else {
    const file = FileSystem.stat(fileData as string);
    return file;
  }
};

export const removeObject = async (
  objectItem: Media | Folder,
): Promise<void> => {
  try {
    if (Platform.OS === 'web') {
      const dirCore = await window.navigator.storage.getDirectory();
      if ((objectItem as Media).isMediaNew) {
        const media = objectItem as Media;
        const fileId = `${media.id}_${media.filename}`;
        const dir = await dirCore.getDirectoryHandle(media.folderId);
        dir.removeEntry(fileId);
      } else {
        // const dir = await dirCore.getDirectoryHandle(objectItem.folderId as string);
        dirCore.removeEntry(objectItem.id, {recursive: true});
      }
    } else {
      if ((objectItem as Media).isMediaNew) {
        const media = objectItem as Media;
        const filePath = (await getFileReaderOpfs(media)) as string;
        await ExpoFileSystem.deleteAsync(filePath);
      } else {
        await ExpoFileSystem.deleteAsync(objectItem.id);
      }
    }
  } catch (err) {
    console.error('delete file rror', err);
  }
};

export const getFileOpfs = async (
  media: Media,
): Promise<string | undefined> => {
  try {
    console.info('get file', media.id);

    const file = await getFileReaderOpfs(media);
    if (typeof file === 'string') return file;

    if (!file) throw 'no_file_found';

    const url = URL.createObjectURL(file);
    return url;
  } catch (err) {
    // console.error('get file error', err);
    throw err;
  }
};

export const exportFile = async (media: Media): Promise<void> => {
  if (Platform.OS === 'web') {
    const file = (await getFileOpfs(media)) as string;
    const a = document.createElement('a');
    a.style = 'display:none;';
    document.body.appendChild(a);
    a.download = media.filename;
    a.href = file;
    a.click();
  } else {
    const {share} = useShare();
    const file = (await getFileReaderOpfs(media)) as string;
    share(file);
  }
};

export const getFileReaderOpfs = async (
  media: Media,
): Promise<File | string | undefined> => {
  try {
    const fileId = `${media.id}_${media.filename}`;
    if (Platform.OS === 'web') {
      const dirCore = await window.navigator.storage.getDirectory();
      const dir = await dirCore.getDirectoryHandle(media.folderId, {
        create: true,
      });
      const fileHandle = await dir.getFileHandle(fileId);
      const file = await fileHandle?.getFile();
      return file;
    } else {
      const directoryUri = `${ExpoFileSystem.documentDirectory}${media.folderId}`;
      const dirExists = await ExpoFileSystem.getInfoAsync(
        directoryUri,
      );
      console.info('dirExists', dirExists);
      if (dirExists.exists === false) return undefined;
      const fileUri = `${directoryUri}/${fileId}`;
      console.info('fileUri', fileUri);
      const file = await ExpoFileSystem.getInfoAsync(fileUri);
      console.info('rn fs file', file);
      return (file?.exists && file.uri) || undefined;
    }
  } catch (err) {
    // console.error('get file reader error', err);
  }
};
let chunksCount = {};
let savePromises = {};
let savesCompleted = {};
export const saveFileToData = async (
  filename: string,
  fileUri: string,
  saveCount: number,
): Promise<void> => {
  console.info(
    'save ',
    filename,
    saveCount,
    savesCompleted[filename],
  );
  if (savePromises[filename])
    return savePromises[filename].then(() =>
      saveFileToData(filename, fileUri, saveCount),
    );
  else
    savePromises[filename] = new Promise(async (resolve, rej) => {
      try {
        const {readBlobs} = await createBlobDB();
        let blobs = await readBlobs(filename);
        let bbs = blobs.map(i => i.data);
        let buffers = bbs.reduce(
          (a, i) => _appendBuffer(a, Uint8Array.from(i)),
          new Uint8Array(),
        );
        if (chunksCount[filename])
          chunksCount[filename] += blobs.length;
        else chunksCount[filename] = blobs.length;
        // console.info(
        //   'save file to data',
        //   filename,
        //   buffers.length,
        //   blobs.length,
        //   bbs.length,
        // );
        // console.info(
        //   'current chunk on saving file',
        //   chunksCount[filename],
        // );
        let nfile = getBlobForArrayBuffer(buffers.buffer) as Blob & {
          name: string;
        };
        nfile.name = filename;
        const fr = new FileReader();
        fr.onload = async () => {
          // console.info('file reader result', fr)
          try {
            const data = fr.result.replace('data:blob;base64,', '');
            await FileSystem.appendFile(
              fileUri.replace('file://', ''),
              data,
              'base64',
            );
            resolve(null);
          } catch (err) {
            const error = (err as Error)?.message || err;
            console.error('fs worker err', error);
            rej(error);
          }
        };
        fr.readAsDataURL(nfile);
      } catch (err) {
        savePromises[filename] = null;
        console.error(
          'fs worker err',
          (err as Error)?.message || err,
        );
        rej((err as Error)?.message || err);
      }
    });
  await savePromises[filename];
  if (savesCompleted[filename])
    savesCompleted[filename].push(saveCount);
  else savesCompleted[filename] = [saveCount];
  savePromises[filename] = null;
};

export const _appendBuffer = function (
  buffer1: ArrayBuffer,
  buffer2: ArrayBuffer,
) {
  const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  tmp.set(new Uint8Array(buffer1), 0);
  tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
  return tmp;
};

export const DocumentPicker = {
  pickSingle: async () =>
    new Promise(async resolve => {
      if (Platform.OS === 'web') {
        const fileInput = document.getElementById(
          'fileInput',
        ) as HTMLInputElement | null;
        fileInput?.click();
        fileInput?.addEventListener('change', async () => {
          if (fileInput?.files?.length) {
            const file = fileInput?.files?.[0];
            const nfile = {
              file,
              type: file?.type,
              title: file?.name,
              name: file?.name,
              extractor: 'local',
              size: file?.size,
              originalId: file?.name + file?.size,
            };
            return resolve(nfile);
          }
        });
      } else {
        const exres = await ExpoDocumentPicker.getDocumentAsync({
          multiple: false,
        });
        const asset = exres?.assets?.[0];
        console.info('expo res', exres, asset);
        if (!asset) return resolve(undefined);
        const nfile = {
          asset,
          file: asset,
          uri: asset.uri,
          type: asset.mimeType,
          size: asset.size,
          title: asset.name,
          name: asset.name,
          extractor: 'local',
          originalId: asset.name + asset.size,
        };
        return resolve(nfile);
      }
    }),
};
